import { H3 } from "@/components/Typographies"
import { Flex } from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"
import { FileExplorer } from "./components/FileExplorer"

export const Documents: React.FC = () => {
  return (
    <>
      <Flex flexDir="column" gap="6" px={{ base: 4, md: 8 }} py={{ base: 6, md: 12 }}>
        <H3>
          <FormattedMessage id="resources.documents" />
        </H3>
      </Flex>

      <Flex flexDir="column" gap="6" px={{ base: 4, md: 8 }} py={{ base: 6, md: 12 }}>
        <FileExplorer />
      </Flex>
    </>
  )
}
